import React from 'react';

// helpers
import {useScreenWidth} from '../../../hooks';
import {useTheme} from '@emotion/react';

// components
import CardDetailsLoanMobile from './CardDetailsLoanMobile';
import CardDetailsLoanDesktop from './CardDetailsLoanDesktop';

// types
import {Loan, LoanDetails} from '../../../services/ApiService/types';

export type CardDetailsLoanProps =
  | {
      loan: Loan;
      variant: 'summary';
    }
  | {
      loan: LoanDetails;
      variant: 'detailed';
    };

const CardDetailsLoan = (props: CardDetailsLoanProps) => {
  const screenWidth = useScreenWidth();
  const theme = useTheme();

  return (
    <>
      {screenWidth < theme.screenBreakpoint.md.value ? (
        <CardDetailsLoanMobile {...props} />
      ) : (
        <CardDetailsLoanDesktop {...props} />
      )}
    </>
  );
};

export default CardDetailsLoan;
